import { Injectable, inject, computed, resource } from "@angular/core";
import { IframeMessagesService } from "../iframe-messages-service/iframe-messages.service";
import { ResponseErrorHandlerService } from "../response-error-handler-service/response-error-handler.service";
import type { IFirmUser, IiFirmUsersMap } from "@interfaces/index";

@Injectable({ providedIn: "root" })
export class IFirmUsersService {
    private iframeMessagesService = inject(IframeMessagesService);
    private readonly responseErrorHandlerService = inject(ResponseErrorHandlerService);
    private iFirmUsersLoadPromise: Promise<IFirmUser[]> | null = null;
    public Users: IFirmUser[] = [];
    private usersResource = resource<IFirmUser[], undefined>({
        defaultValue: [],
        loader: () => this.getUsers(),
    });
    public sUsers = computed(() => this.usersResource.value());

    readonly users = computed<IiFirmUsersMap>(() => {
        const items = this.sUsers();
        if (!items || !items.length) return;

        const map: IiFirmUsersMap = new Map();
        for (const user of items) map.set(user.UserId.toString(), user);
        return map;
    });

    async loadiFirmUsers() {
        try {
            const result = await this.iframeMessagesService.postMessageResp("getiFirmUsers", {}, "gotiFirmUsers");
            if (result.status === "success") {
                this.Users = result.users.Data;
                return this.Users;
            }
            this.responseErrorHandlerService.showPopup({
                typeLayout: "ERROR",
                messageCode: "defaultError",
            });
        } catch (error) {
            this.responseErrorHandlerService.showPopup({
                typeLayout: "ERROR",
                messageCode: "defaultError",
            });
        }
        return [];
    }

    async getUsers() {
        if (!this.iFirmUsersLoadPromise) {
            this.iFirmUsersLoadPromise = this.loadiFirmUsers();
        }
        return this.iFirmUsersLoadPromise;
    }
}
